import { CheckCircle2, XCircle, AlertCircle, Info } from 'lucide-react';

const styles = {
  success: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400',
  error: 'bg-rose-500/10 border-rose-500/30 text-rose-400',
  warning: 'bg-amber-500/10 border-amber-500/30 text-amber-400',
  info: 'bg-cyan-500/10 border-cyan-500/30 text-cyan-400',
};

const icons = { success: CheckCircle2, error: XCircle, warning: AlertCircle, info: Info };

export function Alert({ variant = 'info', children, className = '' }) {
  const Icon = icons[variant];
  return (
    <div className={`flex items-start gap-3 px-4 py-3 border rounded-lg ${styles[variant]} ${className}`}>
      <Icon size={18} className="shrink-0 mt-0.5" />
      <div className="text-sm flex-1">{children}</div>
    </div>
  );
}
